/*
 * Description of what this file is for
 *
 * @package  de.bistum-passau.www
 * @author Theresa Obermayr [theresa@fredmansky.at]
 * datepickerCalendar
 */

import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de';
import getAncestorWith from '../../jsHelper/getAncestorWith';

const datepickerCalendar = {
  cfg: {
    name: 'datepickerCalendar',
    selectors: {
      datePicker: '.o-datepickerCalendar',
      dateFiled: '.o-datepickerCalendar__input',
    },
    els: {
      $datePickers: undefined,
    },
  },

  setElements() {
    this.cfg.els.$datePickers = document.querySelectorAll(this.cfg.selectors.datePicker);
  },

  initDatePicker(elem) {
    const self = this;
    const inputField = elem.querySelector(this.cfg.selectors.dateFiled);
    const form = getAncestorWith('form', inputField);
    let minDate = elem.getAttribute('data-min-date');
    if (minDate) {
      minDate = new Date(minDate);
    }
    let maxDate = elem.getAttribute('data-max-date');
    if (maxDate) {
      maxDate = new Date(maxDate);
    }

    if (inputField && form) {
      flatpickr(inputField, {
        minDate: minDate,
        maxDate: maxDate,
        dateFormat: 'd-m-Y',
        locale: German,
        inline: true,
        disableMobile: true,
        onReady: function (selectedDates, dateStr, instance) {
          const hideYear = instance._input.getAttribute('data-hide-year-select') === 'true';
          const reorder = instance._input.getAttribute('data-reorder-months') === 'true';

          if (hideYear) {
            self.hideYearSelect(selectedDates, dateStr, instance);
          }

          if (reorder) {
            self.reorderMonthDropdown(instance);
          }
        },
        onMonthChange: function (selectedDates, dateStr, instance) {
         self.reorderMonthDropdown(instance);
        },
      });

      inputField.addEventListener('change', () => {
        form.submit();
      });
    }

  },

  hideYearSelect(selectedDates, dateStr, instance) {
    const yearInputWrapper = instance.calendarContainer.querySelector('.flatpickr-current-month .numInputWrapper');
    const arrowRight = instance.calendarContainer.querySelector('.flatpickr-next-month');
    const arrowLeft = instance.calendarContainer.querySelector('.flatpickr-prev-month');
    const monthInputWrapper = instance.calendarContainer.querySelector('.flatpickr-monthDropdown-months');
    if (yearInputWrapper) {
      yearInputWrapper.style.display = 'none';
      arrowRight.style.display = 'none';
      arrowLeft.style.display = 'none';
      monthInputWrapper.style.width = '100%';
    }
  },

  reorderMonthDropdown(instance) {
    const monthSelect = instance.calendarContainer.querySelector('.flatpickr-monthDropdown-months');
    if (!monthSelect || monthSelect.firstChild.value === 11) return;
    setTimeout(() => {
      const reorderedMonths = [
        {label: 'Dezember', value: 11},
        {label: 'Januar', value: 0},
        {label: 'Februar', value: 1},
        {label: 'März', value: 2},
        {label: 'April', value: 3},
        {label: 'Mai', value: 4},
        {label: 'Juni', value: 5},
        {label: 'Juli', value: 6},
        {label: 'August', value: 7},
        {label: 'September', value: 8},
        {label: 'Oktober', value: 9},
        {label: 'November', value: 10},
      ];

      let currentMonth = instance.currentMonth;

      monthSelect.innerHTML = '';
      reorderedMonths.forEach((month, index) => {
        const option = document.createElement('option');
        option.textContent = month.label;
        option.value = month.value;
        if (month.value === currentMonth) {
          option.selected = true;
        }
        monthSelect.appendChild(option);
      });

      monthSelect.addEventListener('change', function (e) {
        const newMonthValue = parseInt(e.target.value, 10);
        const year = newMonthValue === 11
          ? instance.config.minDate.getFullYear()  // December = previous year
          : instance.config.maxDate.getFullYear(); // Jan–Nov = current year

        const newDate = new Date(year, newMonthValue, 1);
        instance.jumpToDate(newDate);
      });
    },300)
  },

  init() {
    this.setElements();

    if (this.cfg.els.$datePickers) {
      for (let i = 0; i < this.cfg.els.$datePickers.length; i++) {
        this.initDatePicker(this.cfg.els.$datePickers[i]);
      }
    }
  },
};

export default datepickerCalendar;
